import { Breadcrumbs } from '@repo/foundations';
import {
	NavBarBreadcrumbWrapper,
	NavBarWrapper,
} from '../../../components/SecodaAppShell/SecodaNavBar';

export function AiChatsPageNavBar() {
	return (
		<NavBarWrapper>
			<NavBarBreadcrumbWrapper>
				<Breadcrumbs
					crumbs={[
						{ title: 'Analytics', href: '/analytics' },
						{
							title: 'AI Analytics',
							href: '/analytics/ai-analytics',
						},
						{ title: 'AI Chats', href: '/analytics/ai-chats' },
					]}
				/>
			</NavBarBreadcrumbWrapper>
		</NavBarWrapper>
	);
}

export default AiChatsPageNavBar;
